<template>
  <div id="app">
    <b-container>
      <div class="menubox">
        <div class="col">
          <div class="logobox">
            <a href="/"><img class="logo" src="./assets/logo.png"/></a>
          </div>
        </div>
        <div class="col">
          <div class="logout" v-if="token">
            <b-button @click="logOut" variant="danger">Log out</b-button>
          </div>
        </div>
      </div>
      <div v-if="token">
        <ProducersList v-if="!stream" :token="token" @feedPlayer="feedPlayer"></ProducersList>
        <Player v-if="stream" :stream="stream" @returnToList="returnToList"></Player>
      </div>
      <div v-else>
        <LoginForm @logged="onLogged"></LoginForm>
      </div>
    </b-container>
    <b-container>
      <div class="footer">
      <p>© <a href="http://automatic.tv">AUTOMATICTV</a> 2020 - IS A <a href="https://www.mediapro.tv/">MEDIAPRO</a> GROUP COMPANY</p>
      </div>
    </b-container>
  </div>
</template>

<script>
import ProducersList from "./components/ProducersList.vue";
import Player from "./components/Player.vue";
import LoginForm from "./components/LoginForm.vue";

export default {
  name: "app",
  components: {
    ProducersList,
    LoginForm,
    Player
  },
  data() {
    return {
      token: undefined,
      stream: undefined
    };
  },
  created() {
    if (this.$cookie.get("token")) {
      this.token = this.$cookie.get("token");
    }
  },
  methods: {
    returnToList() {
      this.stream = undefined;
    },
    feedPlayer(stream) {
      this.stream = stream;
    },
    logOut() {
      this.token = undefined;
      this.$cookie.delete("token");
    },
    onLogged(token) {
      this.token = token;
      this.$cookie.set("token", token);
    }
  }
};
</script>

